import { Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@gfe/core/services/icons/icons.service';

import { ButtonComponent } from '@shared/components/button/button.component';

export interface PaginationConfig {
  currentPage: number;
  totalPages: number;
}

export type PaginationOrientation = 'horizontal' | 'vertical';

@Component({
  selector: 'app-pagination',
  imports: [TranslatePipe, ButtonComponent],
  templateUrl: './pagination.component.html'
})
export class PaginationComponent {
  protected readonly ICONS = ICONS;
  paginationConfig = input<PaginationConfig>({
    currentPage: 1,
    totalPages: 1
  });

  orientation = input<PaginationOrientation>('horizontal');

  pageChange = output<number>();

  canGoPrevious = computed(() => this.paginationConfig().currentPage > 1);
  canGoNext = computed(
    () => this.paginationConfig().currentPage < this.paginationConfig().totalPages
  );

  goToPrevious(): void {
    if (this.canGoPrevious()) {
      const newPage = this.paginationConfig().currentPage - 1;
      this.pageChange.emit(newPage);
    }
  }

  goToNext(): void {
    if (this.canGoNext()) {
      const newPage = this.paginationConfig().currentPage + 1;
      this.pageChange.emit(newPage);
    }
  }
}
